const PERMISSION_CATEGORY_LABEL_KEYS = {
  member: "permission_category_member",
  sub_account: "permission_category_sub_account",
  company: "permission_category_company",
  senior_account: "permission_category_senior_account",
  master_account: "permission_category_master_account",
  agent: "permission_category_agent",
  commission: "permission_category_commission",
  payrate: "permission_category_payrate",
  limited_number: "permission_category_limited_number",
  fight_limit: "permission_category_fight_limit",
  win_lose: "permission_category_win_lose",
  result: "permission_category_result",
  lotto_wait: "permission_category_lotto_wait",
  activity_log: "permission_category_activity_log",
  login_log: "permission_category_login_log",
  bet: "permission_category_bet",
  billcut: "permission_category_billcut",
  hanoi: "permission_category_hanoi",
  memberlog: "permission_category_memberlog",
  order: "permission_category_order",
  permission: "permission_category_permission",
  transaction: "permission_category_transaction",
  waitresultuser: "permission_category_waitresultuser",
  waitresulttype: "permission_category_waitresulttype",
  lottobet: "permission_category_lottobet",
  lotto_reward_type_group: "permission_category_lotto_reward_type_group",
  lotto_type: "permission_category_lotto_type",
  schedule: "permission_category_schedule",
};

const PERMISSION_LABEL_KEYS = {
  member_view: "permission_label_member_view",
  member_add: "permission_label_member_add",
  member_edit: "permission_label_member_edit",
  member_delete: "permission_label_member_delete",
  sub_account_view: "permission_label_sub_account_view",
  sub_account_add: "permission_label_sub_account_add",
  sub_account_edit: "permission_label_sub_account_edit",
  sub_account_delete: "permission_label_sub_account_delete",
  company_view: "permission_label_company_view",
  company_add: "permission_label_company_add",
  company_edit: "permission_label_company_edit",
  company_delete: "permission_label_company_delete",
  senior_account_view: "permission_label_senior_account_view",
  senior_account_add: "permission_label_senior_account_add",
  senior_account_edit: "permission_label_senior_account_edit",
  senior_account_delete: "permission_label_senior_account_delete",
  master_account_view: "permission_label_master_account_view",
  master_account_add: "permission_label_master_account_add",
  master_account_edit: "permission_label_master_account_edit",
  master_account_delete: "permission_label_master_account_delete",
  agent_view: "permission_label_agent_view",
  agent_add: "permission_label_agent_add",
  agent_edit: "permission_label_agent_edit",
  agent_delete: "permission_label_agent_delete",
  commission_view: "permission_label_commission_view",
  commission_edit: "permission_label_commission_edit",
  payrate_view: "permission_label_payrate_view",
  payrate_edit: "permission_label_payrate_edit",
  payrate_on_off: "permission_label_payrate_on_off",
  limited_number_view: "permission_label_limited_number_view",
  limited_number_add: "permission_label_limited_number_add",
  limited_number_edit: "permission_label_limited_number_edit",
  limited_number_delete: "permission_label_limited_number_delete",
  fight_limit_view: "permission_label_fight_limit_view",
  fight_limit_edit: "permission_label_fight_limit_edit",
  win_lose_view: "permission_label_win_lose_view",
  result_view: "permission_label_result_view",
  lotto_wait_view: "permission_label_lotto_wait_view",
  activity_log_view: "permission_label_activity_log_view",
  login_log_view: "permission_label_login_log_view",
  bet_view: "permission_label_bet_view",
  bet_edit: "permission_label_bet_edit",
  billcut_view: "permission_label_billcut_view",
  billcut_edit: "permission_label_billcut_edit",
  hanoi_edit: "permission_label_hanoi_edit",
  memberlog_view: "permission_label_memberlog_view",
  memberlog_edit: "permission_label_memberlog_edit",
  order_view: "permission_label_order_view",
  order_edit: "permission_label_order_edit",
  permission_view: "permission_label_permission_view",
  permission_edit: "permission_label_permission_edit",
  transaction_view: "permission_label_transaction_view",
  waitresultuser_view: "permission_label_waitresultuser_view",
  waitresulttype_view: "permission_label_waitresulttype_view",
  lottobet_view: "permission_label_lottobet_view",
  lotto_reward_type_group_view: "permission_label_lotto_reward_type_group_view",
  lotto_reward_type_group_add: "permission_label_lotto_reward_type_group_add",
  lotto_reward_type_group_edit: "permission_label_lotto_reward_type_group_edit",
  lotto_reward_type_group_delete:
    "permission_label_lotto_reward_type_group_delete",
  lotto_type_view: "permission_label_lotto_type_view",
  lotto_type_add: "permission_label_lotto_type_add",
  lotto_type_edit: "permission_label_lotto_type_edit",
  lotto_type_delete: "permission_label_lotto_type_delete",
  schedule_view: "permission_label_schedule_view",
  schedule_add: "permission_label_schedule_add",
  schedule_edit: "permission_label_schedule_edit",
  schedule_delete: "permission_label_schedule_delete",
};

export const getPermissionCategoryKey = (name) => {
  if (!name) return "other";
  return name.replace(/_(view|add|edit|delete|on_off)$/, "");
};

export const getPermissionCategoryLabelKey = (categoryKey) =>
  PERMISSION_CATEGORY_LABEL_KEYS[categoryKey] || "permission_category_other";

export const getPermissionLabelKey = (name) => PERMISSION_LABEL_KEYS[name];

export const getPermissionLabel = (item, t) => {
  const key = getPermissionLabelKey(item.name);
  return key ? t(key) : item.description;
};

export const groupPermissions = (items) =>
  items.reduce((groups, item) => {
    const category = getPermissionCategoryKey(item.name);
    if (!groups[category]) groups[category] = [];
    groups[category].push(item);
    return groups;
  }, {});
